module.exports = __webpack_public_path__ + "img/2614.bc1b948.svg";